import styles from "./Dropdown.module.css";
import exitIcon from "../../../../../assets/x-background.png";
import exitIcon2 from "../../../../../assets/x-highlight.png";
import useScrollStop from "../../../../hooks/use-scroll-stop";
export default function Dropdown({
  showOptions,
  categories,
  filters,
  setFilters,
  setShowOptions,
}) {
  const onCheckHandler = (e) => {
    const { checked } = e.target;
    let { value } = e.target;
    value = parseInt(value);

    let tempArray = [...filters];

    if (checked) {
      tempArray = [...tempArray, value];
    } else {
      tempArray = [...tempArray.filter((e) => e !== value)];
    }

    setFilters(tempArray);
  };

  const onFilteringClose = () => {
    setShowOptions(false);
  };

  const cancelAllFilters = () => {
    setFilters([]);
  };

  return (
    <main>
      {showOptions && (
        <div className={styles.dropdown}>
          <div className={styles[`mobile-header`]}>
            <div className={styles.title}>Filtriranje kategorija</div>
            <img
              className={styles.exit}
              src={exitIcon2}
              alt="X"
              onClick={onFilteringClose}
            />
            <div
              className={`${styles.cancel} ${
                styles[filters.length > 0 && `cancel-active`]
              }`}
              onClick={cancelAllFilters}
            >
              <img src={exitIcon2} alt="x" className={styles[`exit-icon2`]} />
              Poništi sve
            </div>
          </div>

          <div className={styles[`options-container`]}>
            {categories.map((category, key) => {
              return (
                <label
                  key={key}
                  className={`${styles.option} ${
                    styles[filters.includes(category.ID) && `option-active`]
                  }`}
                >
                  <input
                    type="checkbox"
                    value={category.ID}
                    onChange={onCheckHandler}
                    checked={filters.includes(category.ID) ? "checked" : ""}
                  />
                  {category.post_title}
                </label>
              );
            })}
            <div className={styles[`options-bottom-padding`]} />
          </div>
        </div>
      )}
    </main>
  );
}
